import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: 7,
    government: 5,
    office: 15,
  },
  education: {
    childcare: 2,
    high_school: 3,
    library: 5,
    primary: 2,
    university: 7,
  },
  essentials: {
    electricity: 15,
    gas: 12,
    sewers: 12,
    waste: 12,
    water: 15,
  },
  food: {
    bakery: 5,
    coffee: 15,
    fast_food: 8,
    restaurant: 7,
  },
  health: {
    clinic: 8,
    dentist: 6,
    hospital: 5,
    pharmacy: 7,
  },
  nature: {
    beach: -10,
    forest: -5,
    lake: -5,
    mountain: -10,
    park: 5,
    river: -5,
  },
  religion: {
    church: -5,
    mosque: -5,
  },
  shops: {
    grocery: 12,
    mall: 5,
  },
  soil: {
    clay: 0,
    loam: 0,
    peat: -5,
    salt: -10,
    sand: -5,
    silt: 0,
  },
  sport: {
    gym: 10,
    pool: 5,
  },
  telecom: {
    cable_tv: 5,
    fiber_optic: 15,
    network_4g: 12,
    network_5g: 10,
    phone: 15,
  },
  transport: {
    airport: 7,
    bus: 10,
    ferry: -5,
    gas_station: 8,
    metro: 10,
    parking: 12,
    taxi: 10,
    train: 10,
    tram: 7,
  },
};

export default PLACES_PROFILE;
